// CRO Service – create CRO entity via OshimedAPI
import Services, { handleError } from "./index.service";
import { getSession } from "@hooks/useSession";
import { sha256 } from "@crypto";
import Config from "@config";

/**
 * Sends company creation data to Oshimed API /platform backend.
 * Currently returns success=true stub. Implementation will follow.
 */
const { OshimedAPI, OshimedBackend } = Services;

/**
 * @param {object} payload  already formatted by controller (to, entityType, entityData)
 */
const createCompany = async (payload) => {
  try {
    const session = getSession();
    const { user } = session
    if (!user?.email || !session.apiToken) {
      return { success: false, message: "Missing session data", errorCode: "cro-no-session", errorKey: 795001 };
    }

    const emailClear = user.email;
    const hashedEmail = await sha256(emailClear);

    // 1. Get temporary x-api-key
    let tmpKey;
    try {
      const res = await OshimedBackend.get(`/auth/tmp-x-api-key/${hashedEmail}`);
      tmpKey = res.data;
    } catch (err) {
      return handleError(err, 795002);
    }



    if (tmpKey?.success === false) return tmpKey;

    // 2. Get webhook token
    let webhookToken;
    try {
      const res = await OshimedBackend.get(`/webhook/token/${hashedEmail}`);
      webhookToken = res.data;
    } catch (err) {
      return handleError(err, 795004);
    }

    if (webhookToken?.success === false) return webhookToken;

    // 3. Build request body with webhook
    const userId = session.user.userId;
    const body = {
      ...payload,
      webhook: {
        url: `${Config.BACKEND_URL}/entity/register`,
        method: "POST",
        params: {
          webhookToken,
          userId,
          entity:{
            entityType: payload.entityType,
            to: user.didAddress,
            entityData: {...payload.entityData},
          }
        },
      },
    };

    console.log('=== body === cro.service.js === key: 733585 ===');
    console.dir(body, { depth: null, colors: true })
    console.log('=================================');

    // 4. Send to OshimedAPI
    const response = await OshimedAPI.post("/entity/register", body, {
      headers: {
        "x-api-key": tmpKey,
        Authorization: `Bearer ${session.apiToken}`,
      },
    });

    console.log('=== response.data === cro.service.js === key: 879427 ===');
    console.dir(response.data, { depth: null, colors: true })
    console.log('=================================');
    
    return response.data;
  } catch (error) {
    return handleError(error, 795003);
  }
};

export default {
  createCompany,
};
